<div class="generic-toggle">
  @if (options().length > 0) {
    @for (option of options(); track option.value) {
      <button class="toggle-option" [class.active]="selectedValue() === option.value" (click)="setValue(option.value)">
        @if (option.icon) {
          <lucide-icon [name]="option.icon" [size]="18" [strokeWidth]="1.5"></lucide-icon>
        }
        <span class="toggle-text"
          >{{ option.labelPath | labelsProvider }}{{ option.count ? ' ' + option.count : '' }}</span
        >
      </button>
    }
  } @else {
    <button class="toggle-option" [class.active]="selectedOption() === 'option1'" (click)="setToggle('option1')">
      <lucide-icon [name]="option1Icon()" [size]="18" [strokeWidth]="1.5"></lucide-icon>
      <span class="toggle-text">{{ option1Text() }}</span>
    </button>
    <button class="toggle-option" [class.active]="selectedOption() === 'option2'" (click)="setToggle('option2')">
      <lucide-icon [name]="option2Icon()" [size]="18" [strokeWidth]="1.5"></lucide-icon>
      <span class="toggle-text">{{ option2Text() }}</span>
    </button>
  }
</div>
